import { Tokens } from "@accurx/design";
import styled from "styled-components";

export const StyledSubtitle = styled.h3`
    font-size: 1.25rem;
    font-weight: bold;
    color: ${Tokens.COLOURS.greyscale.night};
`;
